
















































import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import LogoSelector from '@ui/LogoSelector'

settings =
  name: "ProfileStep"

  vue:
    props: ['wizard']
    store: ['member']
    mixins: [WizardService.step()]
    components: { LogoSelector }

    computed:
      org: -> @wizard.campaignData.org
      domainName: ->
        { domain, name } = @wizard.campaignData.brand_info
        "#{domain}".trim() || "#{name}".trim() || @member.email.split('@')[1]
      detectedCompanies: -> @wizard.campaignData.company?.detected || []

    methods:
      validateStep: ->
        @validateCompanyName()

      validateCompanyName: ->
        { name } = @wizard.campaignData.company
        unless name and !!"#{name}".trim().length
          @wizard.setFormError 'company_name', 'Enter a company name'
          @wizard.setModelError 'company_name', 'Please, enter a company name'

      hiSelectCompany: (company) ->
        (@wizard.campaignData.company[key] = value) for key, value of company

export default VueOptions.vue settings
